// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__IpSdl","portalLogo":"COM001F1_portalLogo__bP9Ja","infoBox":"COM001F1_infoBox__MjbdB"};